export default __webpack_public_path__ + "static/media/title-section.4ada7490.jpg";